<template>
  <div id="app">
    <Header v-if="isHeader" />
    <div @click="leave">
      <router-view />
    </div>
    <Footer v-if="isConsole" />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ResizeMixin from "@/components/mixin/ResizeHandler";
import eventBus from "./utils/eventBus";
import { emitAccesspath } from "@/api";
// import ws from "@/utils/webSocket";
let ws;
const baseURL = "/api";
export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      visitSource: "",
      nofirst: false,
    };
  },
  mixins: [ResizeMixin],
  computed: {
    isConsole() {
      return (
        this.$route.path.indexOf("/morningMeet/index") *
        this.$route.path.indexOf("/meetingMinuter/index") *
        this.$route.path.indexOf("/businessReport/index") *
        this.$route.path.indexOf("/console") *
        this.$route.path.indexOf("/ProductConsoleRJ") *
        this.$route.path.indexOf("/ScreenDisplayRJ") *
        this.$route.path.indexOf("/DoOneGood") *
        this.$route.path.indexOf("/Message") *
        this.$route.path.indexOf("/MorningMeet") *
        this.$route.path.indexOf("/DayQing") *
        this.$route.path.indexOf("/DoOneGood") *
        this.$route.path.indexOf("/MeetingMinuter") *
        this.$route.path.indexOf("/ApplicationMarket") *
        this.$route.path.indexOf("/login") *
        this.$route.path.indexOf("/register") *
        this.$route.path.indexOf("/forestPwd")
      );
    },
    isHeader() {
      return (
        this.$route.path.indexOf("/morningMeet/index") *
        this.$route.path.indexOf("/meetingMinuter/index") *
        this.$route.path.indexOf("/businessReport/index") *
        this.$route.path.indexOf("/console") *
        this.$route.path.indexOf("/ProductConsoleRJ") *
        this.$route.path.indexOf("/ScreenDisplayRJ") *
        this.$route.path.indexOf("/DoOneGood") *
        this.$route.path.indexOf("/Message") *
        this.$route.path.indexOf("/MorningMeet") *
        this.$route.path.indexOf("/DayQing") *
        this.$route.path.indexOf("/DoOneGood") *
        this.$route.path.indexOf("/MeetingMinuter")
      );
    },
  },
  methods: {
    handleBeforeUnload() {
      emitAccesspath({ recordsState: 1 });
    },
    leave() {
      eventBus.$emit("closeSearch", true);
    },
  },
  created() {
    if (this.$route.query.type == "wechat") {
      this.visitSource = "公众号";
    } else if (this.$route.query.type == "other") {
      this.visitSource = "其他";
    } else if (window.document.referrer) {
      this.visitSource = "搜索引擎";
    } else {
      this.visitSource = "自获客";
    }
    setTimeout(async () => {
      await emitAccesspath({ visitSource: this.visitSource });
    }, 500);
  },
  mounted() {
    // const obj = {
    //   recordsState: 1
    // }
    // if (navigator.sendBeacon) {
    //   window.addEventListener('visibilitychange', () => {
    //     if (document.visibilityState === "hidden") {
    //       navigator.sendBeacon('api/pt/visitor-record//ping', JSON.stringify(obj));
    //     }
    //   });
    //   // navigator.sendBeacon('api/visitor-record/ping', JSON.stringify(obj));

    // } else {
    //   // 备选方案
    //   console.log('不支持');
    // }
    ws = new WebSocket('wss://www.eiiplat.com/ws/socket/connection');//正式
    // ws = new WebSocket("ws://47.96.70.127:9527/pt/socket/connection"); //测试
    // ws.onopen();

    // 触发 prerender 的 render-event
    document.dispatchEvent(new Event('render-event'));
    document.addEventListener("DOMContentLoaded", function() {
      setTimeout(() => {
        const alertDivs = document.querySelectorAll('div[role="alert"]');
        alertDivs.length && alertDivs.forEach(alert => {
          alert.style.display = "none";
        })
      }, 1000)
    });
  },
  beforedestroy() {
    // const obj = {
    //   recordsState: 1
    // }
    // fetch(url, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify({
    //     recordsState: 1,
    //   }),
    //   // 保持连接
    //   keepalive: true,
    // });
    ws.ononclose();
    // window.removeEventListener('visibilitychange', () => {
    //   if (document.visibilityState === "hidden") {
    //     navigator.sendBeacon('api/pt/visitor-record//ping', JSON.stringify(obj));
    //   }
    // });
  },
};
</script>
<style>
/* 设置全局字体 */
/* @font-face {
  font-family: "Oswald";
  src: url("assets/font/Oswald-Regular.ttf");
}
@font-face {
  font-family: "PingFang SC"; */

  /* src: url('assets/font/PingFangRegular.ttf') */
/* } */

/* .ant-fullcalendar {
  border-top: none;
}
.ant-fullcalendar-value {
  font-size: 12px;
}
.ant-fullcalendar-column-header-inner {
  font-size: 12px;
}
.ant-fullcalendar-selected-day .ant-fullcalendar-value, .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
  border-radius: 4px;
} */

.ant-fullcalendar {
  border-top: none;
}

.ant-fullcalendar-calendar-body {
  padding: 20px 0;
}

.ant-fullcalendar-calendar-body {
  padding: 5px 0;
}

.ant-fullcalendar-value {
  display: block;
  width: 30px;
  height: 30px;
  margin: 0 auto;
  padding: 0;
  line-height: 30px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  font-size: 14px;
  border-radius: 8px;
}

.ant-fullcalendar-column-header .ant-fullcalendar-column-header-inner {
  display: block;
  font-weight: 400;
  font-size: 14px;
}

.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value,
.ant-fullcalendar-selected-day .ant-fullcalendar-value {
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  border-radius: 8px;
}

.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value,
.ant-fullcalendar-today .ant-fullcalendar-value {
  -webkit-box-shadow: 0 0 0 1px #1890ff inset;
  border-radius: 8px;
  font-size: 14px;
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.ant-fullcalendar-date,
.ant-fullcalendar-month {
  width: 30px;
  height: 30px;
  margin: 0 auto;
}

.ant-select-sm .ant-select-arrow,
.ant-select-sm .ant-select-selection__clear {
  right: 4px;
  top: 8px;
}

.ant-row-flex-center {
  gap: 8px;
}

/* 所有元素默认字体 */
* {
  /* font-family: -apple-system-font,  Helvetica Neue, Helvetica,
    STHeiTi, sans-serif; */
  /* font-size: 0.18rem; */
}

/* #app {
		width: 19.20rem;
		margin: 0 auto;
	} */

.hidden-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.hidden-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.hidden-4 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.hidden-6 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
}

.el-popup-parent--hidden {
  padding-right: 0px !important;
  overflow: hidden !important;
}

.carousel {
  height: 4rem;
  background-color: #1a1a1a;
  padding-top: 64px;
}

.evenflow * {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  outline: none;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.evenflow {
  display: inline-block;
}

.evenflow:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
}

.evenflow li {
  display: block;
  float: left;
  width: 30%;
  max-width: 400px;
  line-height: 0;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 20px;
  transition: all 0.25s ease;
}

.evenflow li a {
  display: block;
  padding: 8px;
  background: #424242;
  border-radius: 2px;
  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.25);
}

.evenflow li img {
  width: 100%;
}

/* LIGHTBOX TITLE */
.mfp-title {
  font-size: 1.2em;
  color: #ddd !important;
  margin-top: 10px;
  font-weight: 200;
}

/* LIGHTBOX COUNTER */
.mfp-counter {
  font-size: 1.2em;
  color: #ddd !important;
  margin-top: 10px;
  font-weight: 200;
}

/* FULL WIDTH MODE */
.evenflow_full_width li {
  margin: 0;
  width: 33%;
}

.evenflow_full_width li a {
  border-radius: 0;
  padding: 0;
}

/* HOVER EFFECTS */
.evenflow_rotate {
  transition: transform 0.25s ease;
}

.evenflow_rotate:hover {
  transform: rotate(45deg);
}

.evenflow_shiftX {
  transition: transform 1s ease;
}

.evenflow_shiftX:hover {
  transform: translateX(20px);
}

.evenflow_shiftY {
  transition: transform 1s ease;
}

.evenflow_shiftY:hover {
  transform: translateY(-20px);
}

.evenflow_scale {
  cursor: pointer;
  transition: transform 0.25s ease;
}

.evenflow_scale:hover {
  transform: scale(1.1, 1.1);
}

.evenflow_spin {
  transition: transform 0.25s ease;
}

.evenflow_spin:hover {
  transform: rotate(360deg);
}

@keyframes evenflow_shake {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.evenflow_shake {
  transform: scale(1);
}

.evenflow_shake:hover {
  animation-name: evenflow_shake;
  animation-duration: 500ms;
  transform-origin: 50% 50%;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: ease;
}

@media screen and (max-width: 780px) {
  .evenflow li {
    width: 45%;
  }
}

@media screen and (max-width: 550px) {
  .evenflow {
    text-align: center;
  }

  .evenflow li {
    float: none;
    display: inline-block;
    width: 80%;
    margin-bottom: 30px;
  }
}

/* 可以设置不同的进入和离开动画 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(100px);
  opacity: 0;
}

/* .rotation:hover {
    -webkit-transform: rotate(360deg);
    animation: rotation 1s linear infinite;
    -moz-animation: rotation 1s linear infinite;
    -webkit-animation: rotation 1s linear infinite;
    -o-animation: rotation 1s linear infinite;
} */
@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
  }
}

.details-banner {
  width: 100%;
  height: 356px;
  background: #20252f;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue